import mapboxgl from 'mapbox-gl';
import distance from '@turf/distance';

export default {
    init() {
        var ajax_url = ajax_object.ajax_url,
            $this = this;

        if ($('.find-retailer-map').length > 0) {

            $('#findRetailerSearch').on('submit', function (e) {
                e.preventDefault();
                $('.province-dropdown').hide();
                var formData = new FormData($('#findRetailerSearch')[0]);
                formData.append('action', 'retailerCallback');

                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        var data = JSON.parse(this.responseText);
                        var locations = data.locations;
                        if (Array.isArray(locations) && locations.length > 0) {
                            $('#findRetailerSearch  .address-list ul').html(data.htmlGridView);
                            $('#findRetailerSearch  .address-list').show();
                            $('.filter-dropdown').show();
                            document.getElementById('find-retailer-map').innerHTML = '';
                            ajax_object.dealer_map = $this.mapInitialize(locations);
                        } else {
                            $('#findRetailerSearch  .address-list ul').html('<li>Dealer not found...</li>');
                            $('#findRetailerSearch  .address-list').show();
                        }
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            });

            $('body').on('click', '.province-dropdown .address-list ul .item', function (e) {
                e.preventDefault();
                $('.form-footer').hide();
                $('.form-fields').hide();
                $('#result-back-btn-province').show();
                $('.province-dropdown .address-list ul .item').hide();
                $(this).show();
                $(this).find('.list-view').hide();
                $(this).find('.detail-information').show();
                $('.province-heading').hide();

                ajax_object.dealer_map.flyTo({
                    center: [
                        $(this).data('lat'),
                        $(this).data('long'),
                    ],
                    zoom: 12,
                });
            });

            $('body').on('click', '#findRetailerSearch .address-list ul .item', function (e) {
                e.preventDefault();
                $('.form-footer').hide();
                $('.form-fields').hide();
                $('#result-back-btn-new').show();
                $('#findRetailerSearch .address-list ul .item').hide();
                $(this).show();
                $(this).find('.list-view').hide();
                $(this).find('.detail-information').show();

                ajax_object.dealer_map.flyTo({
                    center: [
                        $(this).data('lat'),
                        $(this).data('long'),
                    ],
                    zoom: 12,
                });
            });

            $('body').on('click', '#result-back-btn-new a', function (e) {
                e.preventDefault();
                var vl = $('.form-fields input').val();
                if (vl.length == 0) {
                    $('#findRetailerSearch .address-list').hide();
                }
                $('#findRetailerSearch .address-list ul .item').show();
                $('.detail-information').hide();
                $('.form-footer').show();
                $('.form-fields').show();
                $('.list-view').show();
                $('#result-back-btn-new').hide();
            });

            $('body').on('click', '#result-back-btn-province a', function (e) {
                e.preventDefault();
                var vl = $('.form-fields input').val();
                if (vl.length == 0) {
                    $('.province-dropdown .address-list').hide();
                }
                $('.province-dropdown .address-list ul .item').show();
                $('.detail-information').hide();
                $('.form-footer').show();
                $('.form-fields').show();
                $('.list-view').show();
                $('#result-back-btn-province').hide();
                $('.province-heading').show();
            });

            $('body').on('click', '#findRetailerSearch .clear-field', function (e) {
                e.preventDefault();
                $this.refreshMap($('.find-retailer-map'), true);
            });
        }
    },
    finalize() {
        this.refreshMap($('.find-retailer-map'));
    },
    refreshMap($container, clear) {
        if ($container.length > 0) {
            $('.form-fields input').val('');
            $('#findRetailerSearch .address-list ul').html('');
            $('#findRetailerSearch .address-list').hide();

            var formData = new FormData(),
                $this = this;
            formData.append('action', 'retailerCallback');

            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    var data = JSON.parse(this.responseText);
                    var locations = data.locations;
                    // add search results in list
                    $('#findRetailerSearch  .address-list ul').html(data.htmlGridView);
                    // load map and store in global variable
                    if (clear) {
                        ajax_object.dealer_map.flyTo({
                            center: [
                                locations[0][1],
                                locations[0][2],
                            ],
                            zoom: 5,
                        });
                    } else{
                        ajax_object.dealer_map = $this.mapInitialize(locations);
                    }
                }
            };
            xhttp.open('POST', ajax_object.ajax_url, true);
            xhttp.send(formData);
        }
    },
    mapInitialize(locations, center, zoom) {
        var map = null;
        // initialize mapbox instance
        mapboxgl.accessToken = ajax_object.mapboxgl.access_token;

        map = new mapboxgl.Map({
            container: 'find-retailer-map',
            style: 'mapbox://styles/mapbox/light-v10',
            center: (typeof center !== 'undefined') ? center : [
                parseFloat(locations[0][1]),
                parseFloat(locations[0][2]),
            ],
            zoom: (typeof zoom !== 'undefined') ? zoom : 5,
        });

        // default coords
        var CurrentLat = 24.916787199999998;
        var CurrentLong = 67.0826496;
        // get current coords
        const geolocate = new mapboxgl.GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true,
            },
            trackUserLocation: true,
        });
        map.addControl(geolocate);
        geolocate.on('geolocate', function(e) {
            CurrentLong = e.coords.longitude;
            CurrentLat = e.coords.latitude
        });



        // setTimeout(function(){
        //     navigator.geolocation.getCurrentPosition(position => {
        //         const userCoordinates = [position.coords.longitude, position.coords.latitude];
        //         console.log(userCoordinates);
        //         map.addSource('user-coordinates', {
        //             type: 'geojson',
        //             data: {
        //                 type: 'Feature',
        //                 geometry: {
        //                     type: 'Point',
        //                     coordinates: userCoordinates,
        //                 },
        //             },
        //         });
        //         map.addLayer({
        //             id: 'user-coordinates',
        //             source: 'user-coordinates',
        //             type: 'circle',
        //         });
        //         map.flyTo({
        //             center: userCoordinates,
        //             zoom: 14,
        //         });
        //     });
        // }, 5000);



        var features = [];
        for (var i = 0; i < locations.length; i++) {
            var $distance = distance(
                [CurrentLong, CurrentLat], // from: lng, lat
                [locations[i][1], locations[i][2]], // to: lng, lat
                { units: 'kilometers' }
            );

            var feature = {
                'type': 'Feature',
                'properties': {
                    'title': locations[i][0],
                    'description': locations[i][4],
                    'iconSize': [60, 40],
                    'iconPosition': 'bottom',
                    'message': locations[i][0],
                    'locationid': locations[i][5],
                    'distance': Math.floor($distance),
                },
                'geometry': {
                    'type': 'Point',
                    'coordinates': [locations[i][1], locations[i][2]],
                },
            };
            features.push(feature);
        }

        map.addControl(new mapboxgl.NavigationControl());

        map.on('load', function () {
            const source = 'earthquakes';
            map.resize();
            map.loadImage(
                ajax_object.assets_uri + '/images/map-logo.png',
                function (error, image) {
                    if (error) throw error;

                    map.addImage('marker-img', image);

                    const markerImgLayout = {
                        'icon-image': 'marker-img',
                        'icon-size': 0.55,
                    };

                    map.addSource(source, {
                        type: 'geojson',
                        data: {
                            'type': 'FeatureCollection',
                            'features': features,
                        },
                        cluster: false,
                    });

                    map.addLayer({
                        id: 'points',
                        type: 'symbol',
                        source: source,
                        layout: markerImgLayout,
                    });

                    map.addLayer({
                        id: 'cluster-count',
                        type: 'symbol',
                        source: source,
                        filter: ['has', 'point_count'],
                        layout: Object.assign({}, markerImgLayout, {
                            'text-field': '{point_count_abbreviated}',
                            'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
                            'text-size': 20,
                            'text-offset': [0, -0.5],
                        }),
                        paint: {
                            'text-color': '#fff',
                        },
                    });

                    map.addLayer({
                        id: 'unclustered-point',
                        type: 'circle',
                        source: source,
                        filter: ['!', ['has', 'point_count']],
                        paint: {
                            'circle-color': 'transparent',
                            'circle-radius': 15,
                            'circle-stroke-width': 1,
                            'circle-stroke-color': 'transparent',
                        },
                    });

                    map.on('click', 'unclustered-point', function (e) {
                        var coordinates = e.features[0].geometry.coordinates.slice();
                        var locationid = e.features[0].properties.locationid;
                        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                        }
                        map.flyTo({
                            center: e.features[0].geometry.coordinates,
                            zoom: 12,
                        });
                        if (!$('#result-back-btn-province').is(':visible')) {
                            $('.form-footer').hide();
                            $('.form-fields').hide();
                            $('#result-back-btn-new').show();
                            $('#findRetailerSearch  .address-list').show();
                            $('#findRetailerSearch  .address-list ul .item').hide();
                            $('[data-location_id="' + locationid + '"]').show();
                            $('[data-location_id="' + locationid + '"]').find('.list-view').hide();
                            $('[data-location_id="' + locationid + '"]').find('.detail-information').show();
                        }
                    });
                    map.on('mouseenter', 'cluster-count', function () {
                        map.getCanvas().style.cursor = 'pointer';
                    });
                    map.on('mouseleave', 'cluster-count', function () {
                        map.getCanvas().style.cursor = '';
                    });
                    map.on('mouseenter', 'unclustered-point', function () {
                        map.getCanvas().style.cursor = 'pointer';
                    });
                    map.on('mouseleave', 'unclustered-point', function () {
                        map.getCanvas().style.cursor = '';
                    });
                    features.forEach(function (e) {
                        $('[data-location_id="' + e.properties.locationid + '"] .distance .miles').html(e.properties.distance)
                    });
                }
            );

        });

        return map;
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateFindRetailer.js